'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var lodashOmit = require('lodash/omit');

var moment = require('moment');
var assign = require('object-assign');
var asConfig = require('./utils/asConfig');

var MonthView = require('./MonthView');
var YearView = require('./YearView');
var DecadeView = require('./DecadeView');
var Header = require('./Header');

var toMoment = require('./toMoment');

var hasOwn = function hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};

var onEnter = require('./onEnter');

var Views = {
    month: MonthView,
    year: YearView,
    decade: DecadeView
};

// VENUU-ADD: Avoid deprecation warnings from using React.createFactory
function createFactory(type) {
    return React.createElement.bind(null, type);
}

function emptyFn() {}

class DatePicker extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            view: props.defaultView,
            viewDate: props.defaultViewDate,
            defaultDate: props.defaultDate
        };

        this.gotoNow = this.gotoNow.bind(this);
        this.handleViewChange = this.handleViewChange.bind(this);
        this.handleNavPrev = this.handleNavPrev.bind(this);
        this.handleNavNext = this.handleNavNext.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }

    getViewOrder() {
        return this.props.viewOrder || ['month', 'year', 'decade'];
    }

    getViewName() {
        var view = this.props.view != null ? this.props.view : this.state.view;

        return view || 'month';
    }

    addViewIndex(amount) {
        var viewName = this.getViewName();

        var order = this.getViewOrder();
        var index = order.indexOf(viewName);

        index += amount;

        return index % order.length;
    }

    getNextViewName() {
        return this.getViewOrder()[this.addViewIndex(1)];
    }

    getPrevViewName() {
        return this.getViewOrder()[this.addViewIndex(-1)];
    }

    getView() {
        var views = this.props.views || Views;
        return views[this.getViewName()] || views.month;
    }

    getViewFactory() {
        var view = this.getView();

        // VENUU-ADD: Use hand-rolled createFactory() instead of React.createFactory()
        if (view && view.prototype && typeof view.prototype.render == 'function') {
            view.__factory = view.__factory || createFactory(view);
            view = view.__factory;
        }

        return view;
    }

    getViewDate() {
        var date = hasOwn(this.props, 'viewDate') ? this.props.viewDate : this.state.viewDate;

        date = date || this.viewMoment || this.getDate() || new Date();

        if (moment.isMoment(date)) {
            //in order to strip the locale - the date picker may have had its locale changed
            //between two render calls. If we don't strip this, moment(mom) returns a new moment
            //with the locale of mom, which is not what we want
            date = +date;
        }

        date = this.toMoment(date);

        return date;
    }

    getDate() {
        var date;

        if (hasOwn(this.props, 'date')) {
            date = this.props.date;
        } else {
            date = this.state.defaultDate;
        }

        return date ? this.toMoment(date) : null;
    }

    render() {

        var props = assign({}, this.props);

        this.toMoment = function (value, dateFormat) {
            return toMoment(value, dateFormat || props.dateFormat, { locale: props.locale });
        };

        var view = this.getViewFactory();

        props.date = this.getDate();

        var dateString = props.date == null ? '' : props.date.format(this.props.dateFormat);

        props.viewDate = this.viewMoment = this.getViewDate();
        props.locale = this.props.locale;
        props.localeData = moment.localeData(props.locale);

        props.renderDay = this.props.renderDay;
        props.onRenderDay = this.props.onRenderDay;

        // props.onChange  = this.handleChange
        // props.onSelect  = this.handleSelect

        var className = (this.props.className || '') + ' date-picker';

        props.style = this.prepareStyle(props);

        var viewProps = props;
        var viewProps = asConfig(props);

        viewProps.dateString = dateString;
        viewProps.localeData = props.localeData;
        viewProps.onSelect = this.handleSelect;
        viewProps.onChange = this.handleChange;

        // VENUU-ADD: Remove unwanted props passed to <div> element
        var divProps = lodashOmit(this.props, [
          'minDate',
          'viewOrder',
          'hideFooter',
          'onRenderDay',
          'date',
          'viewDate',
          'onViewDateChange',
          'weekDayNames',
          'weekStartDay',
          'locale',
          'dayFormat',
          'monthFormat',
          'yearFormat',
          'navPrev',
          'navNext',
          'view',
          'maxDate',
          'dateFormat',
          'renderDay',
          'alwaysShowPrevWeek',
          'navOnDateClick',
          'defaultStyle'
        ]);

        return React.createElement(
            'div',
            _extends({}, divProps, { className: className, style: props.style }),
            this.renderHeader(view, props),
            React.createElement(
                'div',
                { className: 'dp-body', style: { flex: 1 } },
                view(viewProps)
            ),
            this.renderFooter(props)
        );
    }

    prepareStyle(props) {
        return assign({}, props.defaultStyle, props.style);
    }

    renderFooter(props) {
        if (this.props.hideFooter) {
            return;
        }

        if (this.props.today) {
            console.warn('Please use "todayText" prop instead of "today"!');
        }
        if (this.props.gotoSelected) {
            console.warn('Please use "gotoSelectedText" prop instead of "gotoSelected"!');
        }

        var todayText = this.props.todayText || 'Today';
        var gotoSelectedText = this.props.gotoSelectedText || 'Go to selected';

        var footerProps = {
            todayText: todayText,
            gotoSelectedText: gotoSelectedText,
            gotoToday: this.gotoNow,
            gotoSelected: this.gotoSelected.bind(this, props),
            date: props.date,
            viewDate: props.viewDate
        };

        var result;
        if (typeof this.props.footerFactory == 'function') {
            result = this.props.footerFactory(footerProps);
        }

        if (result !== undefined) {
            return result;
        }

        return React.createElement(
            'div',
            { className: 'dp-footer' },
            React.createElement(
                'div',
                {
                    tabIndex: '1',
                    role: 'link',
                    className: 'dp-footer-today',
                    onClick: footerProps.gotoToday,
                    onKeyUp: onEnter(footerProps.gotoToday)
                },
                todayText
            ),
            React.createElement(
                'div',
                {
                    tabIndex: '1',
                    role: 'link',
                    className: 'dp-footer-selected',
                    onClick: footerProps.gotoSelected,
                    onKeyUp: onEnter(footerProps.gotoSelected)
                },
                gotoSelectedText
            )
        );
    }

    gotoNow() {
        this.gotoDate(+new Date());
    }

    gotoSelected(props) {
        this.gotoDate(props.date || +new Date());
    }

    gotoDate(value) {

        this.setView('month');

        this.setViewDate(value);
    }

    getViewColspan() {
        var map = {
            month: 5,
            year: 2,
            decade: 2
        };

        return map[this.getViewName()];
    }

    renderHeader(view, props) {

        if (this.props.hideHeader) {
            return;
        }

        props = props || this.props;

        var viewDate = this.getViewDate();
        var headerText = this.getView().getHeaderText(viewDate, props);

        var colspan = this.getViewColspan();
        var prev = this.props.navPrev;
        var next = this.props.navNext;

        return React.createElement(
            Header,
            {
                prevText: prev,
                nextText: next,
                colspan: colspan,
                onPrev: this.handleNavPrev,
                onNext: this.handleNavNext,
                onChange: this.handleViewChange
            },
            headerText
        );
    }

    handleRenderDay(date) {
        return (this.props.renderDay || emptyFn)(date) || [];
    }

    handleViewChange() {
        this.setView(this.getNextViewName());
    }

    /**
     * Use this method to set the view.
     *
     * @param {String} view 'month'/'year'/'decade'
     *
     * It calls onViewChange, and if the view is uncontrolled, also sets it is state,
     * so the datepicker gets re-rendered view the new view
     *
     */
    setView(view) {

        if (typeof this.props.onViewChange == 'function') {
            this.props.onViewChange(view);
        }

        if (this.props.view == null) {
            this.setState({
                view: view
            });
        }
    }

    setViewDate(moment) {

        moment = this.toMoment(moment);

        var fn = this.props.onViewDateChange;

        if (typeof fn == 'function') {

            var text = moment.format(this.props.dateFormat);
            var view = this.getViewName();

            fn(text, moment, view);
        }

        if (!hasOwn(this.props, 'viewDate')) {
            this.setState({
                viewDate: moment
            });
        }
    }

    getNext() {
        var current = this.getViewDate();
        var toMoment = this.toMoment;

        return ({
            month: function month() {
                return toMoment(current).add(1, 'month');
            },
            year: function year() {
                return toMoment(current).add(1, 'year');
            },
            decade: function decade() {
                return toMoment(current).add(10, 'year');
            }
        })[this.getViewName()]();
    }

    getPrev() {
        var current = this.getViewDate();
        var toMoment = this.toMoment;

        return ({
            month: function month() {
                return toMoment(current).add(-1, 'month');
            },
            year: function year() {
                return toMoment(current).add(-1, 'year');
            },
            decade: function decade() {
                return toMoment(current).add(-10, 'year');
            }
        })[this.getViewName()]();
    }

    handleNavigation(direction, event) {
        var viewMoment = direction == -1 ? this.getPrev() : this.getNext();

        this.setViewDate(viewMoment);

        if (typeof this.props.onNav === 'function') {
            var text = viewMoment.format(this.props.dateFormat);
            var view = this.getViewName();

            this.props.onNav(text, viewMoment, view, direction, event);
        }
    }

    handleNavPrev(event) {
        this.handleNavigation(-1, event);
    }

    handleNavNext(event) {
        this.handleNavigation(1, event);
    }

    handleChange(date, event) {
        date = this.toMoment(date);

        if (this.props.navOnDateClick) {
            var viewDate = this.toMoment(this.getViewDate());

            //it's not enough to compare months, since the year can change as well
            //
            //also it's ok to hardcode the format here
            var viewMonth = viewDate.format('YYYY-MM');
            var dateMonth = date.format('YYYY-MM');

            if (dateMonth > viewMonth) {
                this.handleNavNext(event);
            } else if (dateMonth < viewMonth) {
                this.handleNavPrev(event);
            }
        }

        var text = date.format(this.props.dateFormat);

        if (!hasOwn(this.props, 'date')) {
            this.setState({
                defaultDate: text
            });
        }

        ;(this.props.onChange || emptyFn)(text, date, event);
    }

    handleSelect(date, event) {
        var viewName = this.getViewName();

        var property = ({
            decade: 'year',
            year: 'month'
        })[viewName];

        var value = date.get(property);
        var viewMoment = this.toMoment(this.getViewDate()).set(property, value);
        var view = this.getPrevViewName();

        this.setViewDate(viewMoment);

        this.setView(view);

        if (typeof this.props.onSelect === 'function') {
            var text = viewMoment.format(this.props.dateFormat);
            this.props.onSelect(text, viewMoment, view, event);
        }
    }
}

DatePicker.displayName = 'DatePicker';

DatePicker.defaultProps = assign({}, asConfig(), {
    navOnDateClick: true,
    defaultStyle: {
        boxSizing: 'border-box'
    }
});

delete DatePicker.defaultProps.viewDate;
delete DatePicker.defaultProps.date;

DatePicker.views = Views;

// React 19 doesn't check propTypes. Kept, commented out, as the record of
// this component's props for the TypeScript migration.
// DatePicker.propTypes = {
//
//     /**
//      * Function to be called when user selects a date.
//      *
//      * Called with the following params:
//      *
//      * @param {String} dateText Date formatted as string
//      * @param {Moment} moment Moment.js instance
//      * @param {Event} event
//      *
//      * @type {Function}
//      */
//     onChange: PropTypes.func,
//
//     /**
//      * Function to be called when the user navigates to the next/prev month/year/decade
//      *
//      * Called with the following params:
//      *
//      * @param {String} dateText Date formatted as string
//      * @param {Moment} moment Moment.js instance
//      * @param {String} view The name of the current view (eg: "month")
//      * @param {Number} direction 1 or -1. 1 if the right arrow, to nav to next period was pressed. -1 if the left arrow, to nav to the prev period was pressed.
//      * @param {Event} event
//      *
//      * @type {Function}
//      */
//     onNav: PropTypes.func,
//
//     /**
//      * Function to be called when the user selects a year/month.
//      *
//      * Called with the following params:
//      *
//      * @param {String} dateText Date formatted as string
//      * @param {Moment} moment Moment.js instance
//      * @param {String} view The name of the view displayed after following the selection. For now, either "year" or "month"
//      *
//      * @type {Function}
//      */
//     onSelect: PropTypes.func,
//
//     /**
//      * A function that should return a React DOM for the day cell. The first param is the props object.
//      * You can use this to have full control over what gets rendered for a day.
//      *
//      * @param {Object} dayProps The props object passed to day rendering
//      *
//      * @type {Function}
//      */
//     renderDay: PropTypes.func,
//
//     /**
//      * A function that can manipulate the props object for a day, and SHOULD return a props object (a new one, or the same).
//      * Use this for CUSTOM DAY STYLING.
//      * You can use this to take full control over the styles/css classes/attributes applied to the day cell in the month view.
//      *
//      * @param {Object} dayProps
//      * @return {Object} dayProps
//      *
//      * @type {Function}
//      */
//     onRenderDay: PropTypes.func,
//
//     /******************************************/
//     /********** VIEW-related props ************/
//     /******************************************/
//
//     /**
//      * The default view to show in the picker. This is an uncontrolled prop.
//      * If none specified, the default view will be "month"
//      *
//      * @type {String}
//      */
//     defaultView: PropTypes.string,
//
//     /**
//      * The view to show in the picker. This is a CONTROLLED prop!
//      *
//      * When using this controlled prop, make sure you update it when `onViewChange` function is called
//      * if you want to navigate to another view, as expected.
//      *
//      * @type {String}
//      */
//     view: PropTypes.string,
//
//     /**
//      * A function to be called when navigating to another view date.
//      *
//      * Called with the following params:
//      *
//      * @param {String} dateText Date formatted as string
//      * @param {Moment} moment Moment.js instance
//      * @param {String} view the name of the view displayed after the navigation occurs.
//      *
//      * @type {Function}
//      */
//     onViewDateChange: PropTypes.func,
//
//     /**
//      * A function to be called when the view is changed.
//      * If you're using the controlled `view` prop, make sure you update the `view` prop in this function if you want to navigate to another view, as expected.
//      *
//      * @param {String} nextView One of "month", "year", "decade"
//      *
//      * @type {Function}
//      */
//     onViewChange: PropTypes.func,
//
//     /**
//      * Defaults to true. If specified as false, will not navigate to the date that was clicked, even if that date is in the prev/next month
//      * @type {Boolean}
//      */
//     navOnDateClick: PropTypes.bool
// };

module.exports = DatePicker;